import { BorderRadius, Color, PORTAL_CLASS_NAME, Spacing, zIndex } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { DEMO_INVOICE_CONTENT_MAX_WIDTH } from '../../constants/demoInvoiceContentMaxWidth'

export const FullScreenFrame = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  inset: 0;
  z-index: ${zIndex.FullScreenOverlay};
  background-color: ${Color.Lavender100};
`

export const ContentPanel = styled.div`
  flex: 1;
  margin: 0 ${Spacing.S16} ${Spacing.S16};
  border-radius: ${BorderRadius.R16};
  position: relative;
  background-color: ${Color.White};
  overflow: hidden;
`

export const ContentColumn = styled.div`
  max-width: ${DEMO_INVOICE_CONTENT_MAX_WIDTH}px;
  height: 100%;
  margin: 0 auto;
  position: relative;
`

export const PanelOverlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${transparentize(0.52, Color.Grey950)};
`

export const demoInvoiceModalWrapperStyles = css`
  .${PORTAL_CLASS_NAME} {
    background-color: transparent !important;
  }
`
